<template>
  <div class="d-flex h-100 flex-column overflow-auto">
    <TabHeader :header="$t('js.sidebar.headers.locales')" />
    <div class="h-100 p-3 bg-blur-dark">
      <button
        v-for="locale in sharedStore.locales"
        :key="`language_${locale}`"
        class="w-100 btn btn-theme mb-2"
        :class="{ active: locale === currentLocale }"
        @click="sharedStore.setLocale(locale)"
      >
        {{ $t("js.language_name", {}, { locale: locale }) }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import TabHeader from "@/components/frontend/voting/sidebar/TabHeader.vue";
import { useSharedStore } from "@/entrypoints/stores/shared";
import { useI18n } from "vue-i18n";
const { locale: currentLocale } = useI18n();
const sharedStore = useSharedStore();
</script>
